import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import AskUpgrade from '../../components/AskUpgrade.js';
import ColumnPicker from "../../components/ColumnPicker";
import OptionColumn from "../../components/general/OptionColumn";
import Abtest from "./abtest";
import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import SplitRows from '../../components/general/SplitRow.js';

class Abtests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askCreate:false,
            askUpgrade:false,
            askDelete:false,
            followUpFor:false,
            tests:[],
            currentTest:false,
            showDialog:false,
        }

        this.handleSave = this.handleSave.bind(this);
        this.update = this.update.bind(this);
        this.portal = this.portal.bind(this);
        this.renderTest = this.renderTest.bind(this);
        this.renderEmailLine = this.renderEmailLine.bind(this);
        this.generateResult = this.generateResult.bind(this);
        this.askDelete = this.askDelete.bind(this);
        this.delete = this.delete.bind(this);
    }

    askDelete(id) {
        this.setState({askDelete:id});
    }

    delete(id) {
        this.setState({askDelete:false,isLoading:true});
        axios.delete('/emails/abtests/'+id).then(res => {
            this.update();
        });
    }

    generateResult(test) {
        if(parseInt(test.sent_a) < 100 || parseInt(test.sent_b) < 100) {
            return <p>Not enough data. Minimum sent e-mails must be more than 100.</p>;
        }

        if(!test.stats.isSignificant) {
            return <p>E-mail <strong>"{test.stats.winner.toString().toUpperCase()}"</strong> is converting <strong>{test.stats.upLift}%</strong> better than <strong>"{(test.stats.winner == 'a' ? 'B':'A')}"</strong>. Unfortunately, your results are not statistically significant.</p>;
        }

        return <p>E-mail <strong>"{test.stats.winner.toString().toUpperCase()}"</strong> is converting <strong>{test.stats.upLift}%</strong> better than <strong>"{(test.stats.winner == 'a' ? 'B':'A')}"</strong>. Your A/B test is statistically significant!</p>;
    }

    round(num) {
        return num;
    }

    renderEmailLine(test,aOrB) {
        console.dir(test);
        return (
            <tr key={aOrB}>
                <td>
                    {aOrB.toString().toUpperCase()} - #{test['email_id_'+aOrB]}
                </td>
                <td>
                    {test['email_'+aOrB] ? test['email_'+aOrB]['subject']:'-'}
                </td>
                <td>
                    {this.round(test.stats[aOrB].open)}%
                </td>
                <td>
                    {this.round(test.stats[aOrB].click)}%
                </td>
                <td>
                    {this.round(test.stats[aOrB].converted)}%
                </td>
                <td>
                    {test['sent_'+aOrB]}
                </td>
                <td>
                    <div style={{position:'relative'}}>
                        {test.stats.winner == aOrB && test.stats.isSignificant ? <div className="ribbon ribbon-bookmark ribbon-reverse ribbon-warning adjust-to-td">
                            <span className="ribbon-inner"><i className="icon fa-trophy" aria-hidden="true"></i></span>
                        </div>:null}
                    </div>
                </td>
            </tr>

        )
    }

    renderTest(test) {
        return (
            <div key={test.id} >
            <div className="col-lg-12 col-xs-12">
                <div className="panel">
                    <div className="panel-heading">
                        <h3 className="panel-title">Test #{test.id} - {test.description}</h3>
                        <div className="panel-actions">
                            <button onClick={(e) => {this.askDelete(test.id)}} className="btn btn-dark icon wb-trash"></button>
                            &nbsp;
                            <button onClick={e => {this.setState({currentTest:test.id,showDialog:true})}} className="btn btn-dark icon wb-pencil"></button>
                        </div>
                    </div>
                    <div className="alert alert-info">
                        {this.generateResult(test)}
                    </div>
                    <table className="table table-hover">
                        <thead>
                        <tr>
                            <th>A/B</th>
                            <th>Subject</th>
                            <th>Open rate</th>
                            <th>Click rate</th>
                            <th>Conversion rate</th>
                            <th>Sample size</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.renderEmailLine(test,'a')}
                            {this.renderEmailLine(test,'b')}
                        </tbody>
                    </table>
                </div>
            </div>
            <SplitRows/>
            </div>
        )
    }

    portal() {
        return (
            <Portal closeOnEsc onClose={e => {this.setState({currentTest:false,showDialog:false})}} isOpened={this.state.showDialog}>
                <FullScreenOverlay>
                    <Abtest handleSave={this.handleSave} enabled={this.props.general.settings.PACKAGE_ABTEST} onClose={e => {this.setState({currentTest:false,showDialog:false})}} testId={this.state.currentTest} />
                </FullScreenOverlay>
            </Portal>
        )
    }

    handleSave() {
        this.update();
    }

    update() {
        axios.get(`/emails/abtests`)
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'tests':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    componentWillMount() {
        this.update();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.tests.length == 0) {
            return (
                <div className="page-content">
                    <Helmet title="E-mails | Crall.io" />
                    <NoResult
                        header="No tests found"
                        body="You have not created a test yet. Click the button to get started."
                        action={(e) => { this.setState({currentTest:0,showDialog:true}) }}
                        button="Create my first test"
                    />
                    {this.portal()}
                </div>
            );
        }

        return (
            <div className="full-height" id="tests">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-flask"></i> A/B tests</span>
                    <div className="page-header-actions">

                        <div style={{marginRight:'10px'}} className="btn-group dropdown">
                            <button type="button" className="btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                <i className="icon fa-plus" style={{marginRight:'10px'}}></i> Create new
                            </button>
                            <div className="dropdown-menu dropdown-menu-bullet dropdown-menu-right" role="menu">
                                <a onClick={(e) => { this.setState({currentTest:0,showDialog:true}) }} className="dropdown-item" href="javascript:void(0)" role="menuitem">A/B test</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="A/B tests | Crall.io" />

                    <OptionColumn title="A/B tests"  panel={false} description="List of all your A/B tests">
                        {
                            this.state.tests.map(test => {
                                return this.renderTest(test);
                            })
                        }
                    </OptionColumn>


                </div>
                <Confirm onAccept={(e) => { this.delete(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this test?" />

                {this.portal()}
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Abtests = connect(mapStateToProps,mapDispatchToProps)(Abtests);
export default Abtests;



// WEBPACK FOOTER //
// ./containers/emails/abtests.js